import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqs = [
  {
    question: "Who can join this course?",
    answer: "Anyone interested in taxation and compliance can join. It is ideal for students, job seekers, entrepreneurs, accountants, and professionals who want to understand or manage income tax effectively."
  },
  {
    question: "Do I need any prior experience in taxation or accounting?",
    answer: "No prior experience is required. The course starts from the basic concepts of income tax and gradually moves toward advanced and practical applications."
  },
  {
    question: "What topics are covered in this course?",
    answer: "The training covers Income Tax Law, Tax Assessment, Advance Tax, Rebate, Surcharge, Investment, Capital Gain, Online Return Submission, and more. Each module includes both theory and practical sessions."
  },
  {
    question: "Will I learn how to file tax returns online?",
    answer: "Yes. The course includes step-by-step practical training on online tax return submission using the NBR e-filing system."
  },
  {
    question: "What kind of certificate will I receive?",
    answer: "Upon successful completion, participants will receive a Professional Taxation Training Certificate from JK Associates, officially recognizing your skills in taxation and compliance."
  },
  {
    question: "Is this course recognized by employers?",
    answer: "Yes. The certificate from JK Associates adds strong credibility to your profile and is recognized by employers, firms, and financial institutions looking for skilled tax professionals."
  },
  {
    question: "What practical skills will I gain?",
    answer: "You’ll be able to calculate individual and business taxes, prepare and assess returns, determine rebates and exemptions, and file returns both manually and online with confidence."
  },
  {
    question: "Will I get support after course completion?",
    answer: "Absolutely. JK Associates offers lifetime learning support, including updates on tax laws, guidance on real tax issues, and professional advice for your career or business."
  }
];

const TaxationFAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqStyle = (isOpen) => ({
    backgroundColor: isOpen ? "#0d6efd" : "#fff",
    color: isOpen ? "#fff" : "#333",
    borderRadius: "12px",
    padding: "15px 20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s",
  });

  const answerStyle = {
    marginTop: "10px",
    fontSize: "15px",
    lineHeight: "1.5",
    color: "#fff",
  };

  return (
    <section style={{ padding: "60px 20px", backgroundColor: "#f8f9fa" }}>
      <div
        style={{
          backgroundColor: "#0d6efd",
          color: "white",
          padding: "40px 30px",
          borderTopLeftRadius: "40px",
          borderBottomRightRadius: "10px",
          marginBottom: "40px",
        }}
      >
        <h2 style={{ fontSize: "32px", marginBottom: "15px" }}>Frequently Asked Questions</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6", margin: 0 }}>
          Find answers to common questions about the Professional Taxation Training course.
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "15px", maxWidth: "800px", margin: "0 auto" }}>
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              style={faqStyle(isOpen)}
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                {isOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {isOpen && <p style={answerStyle}>{faq.answer}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TaxationFAQSection;
